import type { State, RequestsColumnSettingsState } from './types';

/**
 * Request column settings selectors for accessing column configuration.
 * These selectors are designed to avoid cyclic dependencies.
 */

export const getRequestsColumnSettings = (state: State): RequestsColumnSettingsState => {
    return state.persisted.requestsColumnSettings || [];
};
